(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Campaign Template Communication model for Yumbi Campaigns
     * @constructor
     */
    window.Dashboard.Models.CampaignTemplateCommunication = function () {
        /**
         * The title (Name)
         * @type {string}
         */
        this.Name = "";

        /**
         * The description
         * @type {string}
         */
        this.Description = "";

        /**
         * The minimum offset in days
         * @type {number}
         */
        this.EarliestOffsetFromStart = 0;

        /**
         * The maximum offset in days
         * @type {number}
         */
        this.LatestOffsetFromStart = 60;

        /**
         * The minimum send time
         * @type {Date}
         */
        this.MinSendTime = new Date(2018, 1, 1, 8, 0, 0, 0);

        /**
         * The maximum send time
         * @type {Date}
         */
        this.MaxSendTime = new Date(2018, 1, 1, 20, 0, 0, 0);

        /**
         * The sms
         * @type {Dashboard.Models.TextMessage}
         */
        this.SMS = new window.Dashboard.Models.TextMessage();

        /**
         * The push notification
         * @type {Dashboard.Models.TextMessage}
         */
        this.PushNotification = new window.Dashboard.Models.TextMessage();

        /**
         * The inbox message
         * @type {Dashboard.Models.InboxMessage}
         */
        this.InboxMessage = new window.Dashboard.Models.InboxMessage();

        /**
         * The id
         * @type {number}
         */
        this.Id = 0;
    };

    Dashboard.Models.CampaignTemplateCommunication.prototype = {

        /**
         * Initialises the campaign with the campaign returned from the API
         */
        initialiseCampaignTemplateCommunication: function (campaignTemplateCommunication) {
            return _.extend(this, campaignTemplateCommunication);
        },


        /**
         * Returns true if an SMS has been configured.
         * @returns {boolean}
         */
        HasSMS: function () {
            return this.SMS &&
                !_.isEmpty(this.SMS.Text);
        },

        /**
         * Returns true if a push notification has been configured.
         * @returns {boolean}
         */
        HasPushNotification: function () {
            return this.PushNotification &&
                !_.isEmpty(this.PushNotification.Text);
        },

        /**
         * Returns true if an inbox message has been configured.
         * @returns {boolean}
         */
        HasInboxMessage: function () {
            return this.InboxMessage &&
                !_.isEmpty(this.InboxMessage.Blurb);
        },

        /**
         * Returns the regex used to do the store name replacement
         * @returns {string}
         */
        storeNameRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.StoreName\)/gi;
            }
            return /\{StoreName\}/gi;
        },

        /**
         * Returns the regex used to do the voucher code replacement
         * @returns {string}
         */
        voucherCodeRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.VoucherCode\)/gi;
            }
            return /\{VoucherCode\}/gi;
        },

        /**
         * Returns the regex used to do the brand name replacement
         * @returns {string}
         */
        brandNameRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.BrandName\)/gi;
            }
            return /\{BrandName\}/gi;
        },

        /**
         * Returns the regex used to do the start date replacement
         * @returns {string}
         */
        startDateRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.StartDate\)/gi;
            }
            return /\{StartDate\}/gi;
        },

        /**
         * Returns the regex used to do the start time replacement
         * @returns {string}
         */
        startTimeRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.StartTime\)/gi;
            }
            return /\{StartTime\}/gi;
        },

        /**
         * Returns the regex used to do the end date replacement
         * @returns {string}
         */
        endDateRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.EndDate\)/gi;
            }
            return /\{EndDate\}/gi;
        },

        /**
         * Returns the regex used to do the end time replacement
         * @returns {string}
         */
        endTimeRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.EndTime\)/gi;
            }
            return /\{EndTime\}/gi;
        },

        /**
         * Returns the regex used to do the customer first name replacement
         * @returns {string}
         */
        customerFirstNameRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.CustomerFirstName\)/gi;
            }
            return /\{CustomerFirstName\}/gi;
        },

        /**
         * Returns the regex used to do the customer last name replacement
         * @returns {string}
         */
        customerLastNameRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.CustomerLastName\)/gi;
            }
            return /\{CustomerLastName\}/gi;
        },

        /**
         * Returns the regex used to do the store contact replacement
         * @returns {string}
         */
        storeContactNumberRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.StoreContactNumber\)/gi;
            }
            return /\{StoreContactNumber\}/gi;
        },

        /**
         * Returns the regex used to do the store physical address replacement
         * @returns {string}
         */
        storePhysicalAddressRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.StorePhysicalAddress\)/gi;
            }
            return /\{StorePhysicalAddress\}/gi;
        },

        shortURLRegex: function (messageType) {
            return /\{ShortURL\}/gi;
        },

        voucherExpiryDaysRegex: function (messageType) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return /@Raw\(Model\.VoucherExpiryDays\)/gi;
            }
            return /\{VoucherExpiryDays\}/gi;
        },

        reInitializeCommunicationProperties: function () {
            if (!this.PushNotification) {
                this.PushNotification = new Dashboard.Models.TextMessage();
            }

            if (!this.SMS) {
                this.SMS = new Dashboard.Models.TextMessage();
            }

            if (!this.InboxMessage) {
                this.InboxMessage = new Dashboard.Models.InboxMessage();
            }
        },

        /**
         * Validates the campaign template communication
         * @param {ErrorService} errorService
         * {boolean}
         */
        Validate: function (errorService) {
            let validationPassed = true;

            if (_.isEmpty(this.Name)) {
                errorService.showError('Title Required', null);
                validationPassed = false;
            }

            if (_.isEmpty(this.Description)) {
                errorService.showError('Description Required', null);
                validationPassed = false;
            }

            if (this.EarliestOffsetFromStart < 0) {
                errorService.showError('Earliest offset must be greater than zero', null);
                validationPassed = false;
            }

            if (this.EarliestOffsetFromStart >= this.LatestOffsetFromStart) {
                errorService.showError('Earliest offset from start can not exceed latest offset from start', null);
                validationPassed = false;
            }

            if (this.SMS) {
                if (_.isEmpty(this.SMS.Text)) {
                    errorService.showError('SMS Message Required', null);
                    validationPassed = false;
                }

                if (!this.SMS.ExclusionRule) {
                    this.SMS.ExclusionRule = new Dashboard.Models.ExclusionRules();
                }
            }

            if (this.PushNotification) {
                if (_.isEmpty(this.PushNotification.Text)) {
                    errorService.showError('Pushnotification Message Required', null);
                    validationPassed = false;
                }
            }

            if (this.InboxMessage) {
                if (_.isEmpty(this.InboxMessage.Blurb)) {
                    errorService.showError('Inbox Blurb Required', null);
                    validationPassed = false;
                }

                if (_.isEmpty(this.InboxMessage.Template)) {
                    errorService.showError('Inbox message Required', null);
                    validationPassed = false;
                }

                if (_.isNumber(this.InboxMessage.ExpiresInDays) &&
                    this.InboxMessage.ExpiresInDays <= 0) {
                    errorService.showError('Inbox message expires in days must be greater than zero', null);
                    validationPassed = false;
                }
            }

            return validationPassed;
        }
    }
})();
